const EnvUtils = {
    getAuthorizationUri: () => {
        if (typeof window !== "undefined") {
            // Client-side-only code
            const { origin } = window.location;

            return `${origin}/authorization/`;
        }
    },
    getRedirectUri: () => {
        if (typeof window !== "undefined") {
            // eslint-disable-next-line no-restricted-globals
            const { href } = location;

            //const dev = "http://localhost:3000";
            return encodeURIComponent(href);
        }
    },
};

export default EnvUtils;
